import {
  getLogEmptyStateHeadline,
  LOG_EMPTY_STATE_HINT,
} from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.constants";
import { useGroupedWorkspaceDashboardStyles } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.styles";
import { ILogEmptyStateProps } from "apps/project-iq/components/GroupedWorkspaceDashboard/GroupedWorkspaceDashboard.types";

export const LogEmptyState = ({ logTab }: ILogEmptyStateProps): JSX.Element => {
  const styles = useGroupedWorkspaceDashboardStyles();

  return (
    <div className={styles.logEmptyStateCard}>
      <p className={styles.logEmptyStateHeadline}>
        {getLogEmptyStateHeadline(logTab)}
      </p>
      <p className={styles.logEmptyStateHint}>{LOG_EMPTY_STATE_HINT}</p>
    </div>
  );
};
